
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("Go6xd", function(module, exports) {
/* eslint-disable react/no-this-in-sfc */ 
var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");

var $cs1vW = parcelRequire("cs1vW");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $9VJDA = parcelRequire("9VJDA");


var $g5lKx = parcelRequire("g5lKx");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $hZ7VO = parcelRequire("hZ7VO");


var $jOBr7 = parcelRequire("jOBr7");


var $hicHn = parcelRequire("hicHn");


var $etlkM = parcelRequire("etlkM");

const $9c7adf08392c56c0$export$6cf2d43e95ca2e8b = 5;
const $9c7adf08392c56c0$var$i18n = (0, $h82at.defineMessages)({
    moreCategoriesButton: {
        id: "category-selector.more.categories.button",
        defaultMessage: "More categories"
    }
});
class $9c7adf08392c56c0$var$CategorySelectorInner extends (0, $42omo.Component) {
    render() {
        const { categories: categories, selectedCategoryIds: selectedCategoryIds, numVisibleCategories: numVisibleCategories, isLoading: isLoading } = this.props;
        let visibleCategories = categories;
        let categoriesInMenu = [];
        visibleCategories = categories.reduce((acc, category, index)=>{
            // If category's index is within the number of visible categories or it's selected, add it to the array
            if (index < numVisibleCategories || selectedCategoryIds?.includes(category.id)) acc.push(category);
            return acc;
        }, []);
        // Create a new array where only the unique values of these two arrays appear in expand popup menu
        categoriesInMenu = [
            ...visibleCategories.filter((element)=>!categories.includes(element)),
            ...categories.filter((element)=>!visibleCategories.includes(element))
        ];
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jOBr7.LoadingCategories), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: this.state.isMenuOpen,
            zIndex: (0, $g5lKx.layers).navigation(),
            placement: "bottom",
            onClose: this.handleClose,
            content: this.getMenuContent(categoriesInMenu),
            trigger: this.getTriggerContent(categoriesInMenu, visibleCategories),
            shouldRenderToParent: (0, $9wGTI.fg)('should-render-to-parent-should-be-truetailored-exp')
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isMenuOpen: false
        };
        this.handleCategorySelected = (category)=>{
            const { onCategorySelected: onCategorySelected } = this.props;
            onCategorySelected(category);
            if (this.state.isMenuOpen) this.setState({
                isMenuOpen: false
            });
        };
        this.handleMoreClick = (e)=>{
            e.stopPropagation();
            if (this.props.isDisabled) return;
            this.setState((prevState)=>({
                    isMenuOpen: !prevState.isMenuOpen
                }));
        };
        this.handleClose = ()=>{
            this.setState({
                isMenuOpen: false
            });
        };
        this.getMenuContent = (categoriesInMenu)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.InlineDialogContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.CategoryList), {
                    "data-testid": "more-categories-list"
                }, categoriesInMenu.map((category)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hZ7VO.CategoryItem), {
                        key: category.id,
                        category: category,
                        onClick: this.handleCategorySelected
                    }))));
        this.getTriggerContent = (categoriesInMenu, visibleCategories)=>(triggerProps)=>{
                const { isDisabled: isDisabled, selectedCategoryIds: selectedCategoryIds, intl: intl } = this.props;
                const handleIsSelected = (category)=>selectedCategoryIds?.includes(category.id);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.CategoryList), {
                    "data-testid": "categories-list",
                    onClick: this.handleClose
                }, visibleCategories.map((category)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hZ7VO.CategoryItem), {
                        key: category.id,
                        category: category,
                        isSelected: handleIsSelected(category),
                        isDisabled: isDisabled,
                        onClick: this.handleCategorySelected
                    })), !!categoriesInMenu.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.EllipsisPill), {
                    "data-testid": "more-categories-ellipsis",
                    onClick: this.handleMoreClick,
                    isDisabled: isDisabled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $9c7adf08392c56c0$var$i18n.moreCategoriesButton),
                    delay: 500,
                    hideTooltipOnClick: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                    spacing: "spacious",
                    label: intl.formatMessage($9c7adf08392c56c0$var$i18n.moreCategoriesButton)
                }))))));
            };
    }
}
$9c7adf08392c56c0$var$CategorySelectorInner.defaultProps = {
    numVisibleCategories: $9c7adf08392c56c0$export$6cf2d43e95ca2e8b,
    isDisabled: false,
    onCategorySelected: ()=>{}
};
const $9c7adf08392c56c0$export$9f5f445f63346dec = (0, $etlkM.withErrorBoundary)((0, $cs1vW.default)($9c7adf08392c56c0$var$CategorySelectorInner));
module.exports["DEFAULT_NUM_RENDERED_CATEGORIES"] = $9c7adf08392c56c0$export$6cf2d43e95ca2e8b;
module.exports["CategorySelector"] = $9c7adf08392c56c0$export$9f5f445f63346dec;

});

parcelRegister("hZ7VO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hicHn = parcelRequire("hicHn");


var $jTJby = parcelRequire("jTJby");


var $amedf = parcelRequire("amedf");


var $jg5P6 = parcelRequire("jg5P6");


var $lo6eT = parcelRequire("lo6eT");

class $0d53519f1ad44778$export$41d1d7fbacf843 extends (0, $42omo.Component) {
    render() {
        const { isSelected: isSelected, isDisabled: isDisabled, category: category } = this.props;
        const categoryName = this.getStyledCategoryName(category);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.CategoryPill), {
            isSelected: isSelected,
            isDisabled: isDisabled,
            onClick: this.handleClick,
            onMouseDown: this.handleMouseDown,
            ...isSelected ? {
                'data-testid': 'selected-item'
            } : {},
            tabIndex: isDisabled ? -1 : 0,
            role: "checkbox",
            "aria-checked": isSelected,
            "aria-disabled": isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.TextWrapper), null, categoryName), category.count !== undefined && category.count >= 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.Bold), null, category.count || '') : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.NoCountSpace), null));
    }
    constructor(...args){
        super(...args);
        this.handleClick = ()=>{
            if (this.props.isDisabled) return;
            this.props.onClick(this.props.category);
        };
        this.handleMouseDown = (event)=>{
            event.preventDefault();
        };
        this.getStyledCategoryName = (category)=>{
            if (category.id === 'template.category.featured') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.CategoryNameWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.TrophyIconWrapper), {
                "data-testid": "trophy-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jTJby.TrophyIcon), null)), (0, $lo6eT.i18n).featuredCategoryName.defaultMessage);
            else if (category.id === 'template.category.popular') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.CategoryNameWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.FireIconWrapper), {
                "data-testid": "fire-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amedf.FireIcon), null)), (0, $lo6eT.i18n).popularCategoryName.defaultMessage);
            else if (category.id === 'template.category.my-templates') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.CategoryNameWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hicHn.StarIconWrapper), {
                "data-testid": "star-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jg5P6.MyTemplatesStarIcon), null)), (0, $lo6eT.i18n).myTemplatesCategoryName.defaultMessage);
            else return category.name;
        };
    }
}
module.exports["CategoryItem"] = $0d53519f1ad44778$export$41d1d7fbacf843;

});

parcelRegister("jTJby", function(module, exports) {
/* TrophyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $346dcb3fa3eaabda$var$iconSizeStyles = null;
const $346dcb3fa3eaabda$export$38852ed648a706e8 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 24 24",
        className: (0, $gMc0m.default)([
            "_4t3i7vkz _1bsb7vkz"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M 3.4156 3.333 H 7.4156 C 8.1516 3.333 8.667 3.2637 8.667 3.9997 V 2.6663 C 8.667 1.9303 8.1516 1.333 7.4156 1.333 H 2.0823 C 0.749 1.333 -0.3064 2.7497 0.0823 4.6663 C 0.0823 4.6663 1.2763 10.9163 1.3603 11.305 C 1.5823 12.333 2.7763 13.333 4.0543 13.333 H 8.693 C 9.4296 13.333 8.667 12.069 8.667 11.333 V 9.9997 C 8.667 10.7357 8.1516 11.333 7.4156 11.333 H 4.749 C 4.013 11.333 3.527 10.6383 3.4156 9.9997 C 3.3043 9.361 2.3596 5.111 2.3596 5.111 C 2.1376 3.833 2.679 3.333 3.4156 3.333 Z M 20.6237 3.333 H 16.6236 C 15.8877 3.333 14.667 3.2637 14.667 3.9997 V 2.6663 C 14.667 1.9303 15.8877 1.333 16.6236 1.333 H 21.957 C 23.2904 1.333 24.3463 2.7497 23.9569 4.6663 C 23.9569 4.6663 22.8682 10.9457 22.7763 11.333 C 22.5404 12.333 21.4149 13.333 20.1096 13.333 H 15.3456 C 14.6096 13.333 14.667 12.069 14.667 11.333 V 9.9997 C 14.667 10.7357 15.8877 11.333 16.6236 11.333 H 19.2903 C 20.0264 11.333 20.513 10.6383 20.6237 9.9997 C 20.7343 9.361 21.6796 5.111 21.6796 5.111 C 21.9009 3.833 21.3603 3.333 20.6237 3.333 Z M 13.8883 14.6663 C 13.8883 10.0277 12.0823 14.6663 12.0823 14.6663 C 12.0823 14.6663 10.0823 10.0277 10.0823 14.6663 C 10.0823 19.305 7.8883 21.333 7.8883 21.333 H 16.083 C 16.0823 21.333 13.8883 19.305 13.8883 14.6663 Z",
        fill: "var(--ds-background-accent-orange-subtle, #FCA700)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M 19.415 4.3844 C 19.415 8.9011 14.9016 16.5125 12.0816 16.5125 C 9.261 16.5125 4.7483 8.9011 4.7483 4.3844 C 4.7483 0.9211 5.415 0.1717 6.7483 0.1717 C 7.6643 0.1717 10.765 0.1537 12.0816 0.1537 L 16.7482 0.1531 C 18.693 0.1524 19.415 0.6091 19.415 4.3844 Z",
        fill: "var(--ds-background-warning-bold, #FBC828)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M 18 22.0002 C 18 22.7363 18.1514 23.3335 17.4153 23.3335 H 6.7487 C 6.012 23.3335 6 22.7363 6 22.0002 V 21.3336 C 6 20.5975 6.776 20.0003 7.4707 20.0003 H 16.7487 C 17.4433 20.0003 18 20.5975 18 21.3336 V 22.0002 Z",
        fill: "var(--ds-background-accent-red-subtle, #F87168)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M 19.3336 23.0831 C 19.3336 23.5897 19.4436 23.9997 18.4991 23.9997 H 5.6657 C 4.8043 23.9997 4.667 23.5897 4.667 23.0831 V 22.9164 C 4.667 22.4097 5.159 21.9997 5.6657 21.9997 H 18.4991 C 19.005 21.9997 19.3336 22.4097 19.3336 22.9164 V 23.0831 Z",
        fill: "var(--ds-background-accent-red-subtle, #F87168)"
    }));
};
module.exports["TrophyIcon"] = $346dcb3fa3eaabda$export$38852ed648a706e8;

});

parcelRegister("amedf", function(module, exports) {
/* FireIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $1f2e1ca5af79f277$var$iconSizeStyles = null;
const $1f2e1ca5af79f277$export$98afb0d17ceac256 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 24 24",
        className: (0, $gMc0m.default)([
            "_4t3i7vkz _1bsb7vkz"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_7_29729)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.3334 12.6667C23.3334 11.292 23.0887 9.97402 22.64 8.75468C22.3334 12.3473 20.418 14.1927 18.4167 13.3333C16.542 12.528 17.8054 9.38868 17.8987 7.89068C18.056 5.35135 17.8907 2.44468 13.278 0.0280151C15.1947 3.69468 13.5 5.97268 11.7227 6.11135C9.75069 6.26535 7.94469 4.41668 8.61135 1.41668C6.45269 3.00735 6.39002 5.68468 7.05602 7.41668C7.75069 9.22202 7.02802 10.722 5.33402 10.8887C3.44069 11.0753 2.38869 8.86135 3.35869 5.33335C1.68002 7.31002 0.666687 9.87002 0.666687 12.6667C0.666687 18.926 5.74069 24 12 24C18.2594 24 23.3334 18.926 23.3334 12.6667Z",
        fill: "var(--ds-background-accent-orange-subtle, #FCA700)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.9293 15.9994C19.028 18.0554 17.222 18.8614 16.25 18.472C14.846 17.91 15.2227 16.9447 14.8613 14.9447C14.5 12.9447 13.1113 11.556 11.056 10.9447C12.556 15.1667 10.2247 16.7227 9.00267 17.0007C7.75467 17.2847 6.50067 17 6.35733 14.3294C4.90133 15.7787 4 17.784 4 20C4 20.2454 4.01533 20.4867 4.03667 20.7267C6.08333 22.7494 8.89467 24 12 24C15.1053 24 17.9167 22.7494 19.9633 20.7267C19.9847 20.4867 20 20.2454 20 20C20 18.542 19.6107 17.176 18.9293 15.9994Z",
        fill: "var(--ds-background-accent-orange-subtle, #FCA700)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_7_29729"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "none"
    }))));
};
module.exports["FireIcon"] = $1f2e1ca5af79f277$export$98afb0d17ceac256;

});

parcelRegister("jg5P6", function(module, exports) {
/* MyTemplatesStarIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $5644265f85dddfd2$var$iconSizeStyles = null;
const $5644265f85dddfd2$export$7962414a9e804357 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 24 24",
        className: (0, $gMc0m.default)([
            "_4t3i7vkz _1bsb7vkz"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M 18.1914 23.085 C 17.922 23.085 17.6539 23.0022 17.4234 22.8377 L 12 18.9483 L 6.5767 22.8377 C 6.1147 23.1683 5.4947 23.1683 5.0353 22.8323 C 4.576 22.4995 4.3827 21.909 4.5547 21.3696 L 6.5773 14.8416 L 1.2027 11.0543 C 0.746 10.7176 0.556 10.1256 0.7307 9.5856 C 0.9067 9.0469 1.408 8.6809 1.9747 8.6769 L 8.6313 8.6669 L 10.7507 2.3009 C 10.9293 1.7616 11.4327 1.3989 12 1.3989 C 12.5673 1.3989 13.0707 1.7623 13.25 2.3009 L 15.3333 8.6669 L 22.0241 8.6769 C 22.5927 8.6809 23.0946 9.0476 23.2686 9.5856 C 23.444 10.1256 23.254 10.7176 22.7967 11.0543 L 17.422 14.8416 L 19.4447 21.3696 C 19.6181 21.909 19.4226 22.4995 18.9646 22.8323 C 18.7333 23.0016 18.4626 23.085 18.1914 23.085 Z",
        fill: "var(--ds-background-accent-orange-subtle, #FCA700)"
    }));
};
module.exports["MyTemplatesStarIcon"] = $5644265f85dddfd2$export$7962414a9e804357;

});

parcelRegister("lo6eT", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $59d2229862f6a0d9$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    featuredCategoryName: {
        id: "category-selector.featured.category.name",
        defaultMessage: "Featured"
    },
    popularCategoryName: {
        id: "category-selector.popular.category.name",
        defaultMessage: "Popular"
    },
    myTemplatesCategoryName: {
        id: "category-selector.my-templates.category.name",
        defaultMessage: "My Templates"
    }
});
module.exports["i18n"] = $59d2229862f6a0d9$export$a7357cdd1f0b0168;

});

parcelRegister("etlkM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");

function $fa7264cdce80a603$export$f0c7a449e0cfaec7(CategorySelectorComponent) {
    return (props)=>{
        const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
        const failCategoriesExperience = (0, $42omo.useCallback)((error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE),
                error: error
            });
            experienceTracker.fail({
                name: (0, $irVI7.TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE),
                error: error
            });
        }, [
            experienceTracker
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES,
            onError: failCategoriesExperience
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CategorySelectorComponent, props));
    };
}
module.exports["withErrorBoundary"] = $fa7264cdce80a603$export$f0c7a449e0cfaec7;

});


//# sourceMappingURL=CategorySelector.48ff8521.js.map
